import { render, staticRenderFns } from "./FirstFarmModal.vue?vue&type=template&id=0aba4552&"
import script from "./FirstFarmModal.vue?vue&type=script&lang=js&"
export * from "./FirstFarmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports